import { $Q } from "../utils/query-selector";

export const validateNewsLetter = () => {
  const form = $Q('#ContactFooter');
  const input = $Q('#NewsletterForm--footer');

  if(!form || !input) return;
  form.removeAttribute('action');

  readNewsletterInput(form, input);
  cleanNewsletterInput(form, input);
};

const cleanNewsletterInput = (form, input) => {
  input.addEventListener('input', () => {
    const notification = $Q('.footer__notification--error');
    if(!notification) return;
    form.removeChild(notification);
  })
}

const readNewsletterInput = (form, input) => {
  /**
   * This validation is for when the submit form newsletter,
   * and the email input has already exist,
   * the form let show a message to user, notifying that is subscribed
   * **/
  const searchParams = new URLSearchParams( window.location.search );
  const contactGet = searchParams.get("contact[tags]");
  if(contactGet){
      const error_exist = input.dataset.errorExists;
      const notificationNode = document.createElement('p');
      notificationNode.classList.add('footer__notification', 'footer__notification--error');
      notificationNode.innerText = error_exist;
      form.appendChild(notificationNode);
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();
    const email = input.value;
    const valid = email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if(!valid) {
      const email = $Q('.footer__newsletter-email');
      if(!email) return;

      const notification = email.dataset.error;
      const notificationNode = document.createElement('p');
      notificationNode.classList.add('footer__notification', 'footer__notification--error');
      notificationNode.innerText = notification;
      form.appendChild(notificationNode);
      return;
    }

    form.setAttribute('action', '/contact#ContactFooter');
    form.submit();
  })
}
